import type { AxiosError } from "axios";

// axios's own isAxiosError, inlined so the field app, which never uses axios, doesn't bundle it to run this check.
export function isAxiosError(value: unknown): value is AxiosError {
  return value !== null && typeof value === "object" && "isAxiosError" in value && value.isAxiosError === true;
}
